"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
// const dateNumberToString = (dateNumber: number) => {
//   return `0${dateNumber}`.slice(-2);
// };
function formatValue(value, format, context) {
    switch (format) {
        case 'date': {
            var date = moment_timezone_1.default(Number(value)).tz('Europe/Warsaw');
            // const date = new Date(Number(value));
            if (!date.isValid())
                return '';
            return date.format('DD-MM-yyyy HH:mm');
        }
        case 'hours': {
            var date = moment_timezone_1.default(Number(value)).tz('Europe/Warsaw');
            // const date = new Date(Number(value));
            if (!date.isValid())
                return '';
            return date.format('HH:mm');
        }
        case 'translate': {
            return context.t ? context.t(value) : value;
        }
        case 'round-to-second-place': {
            return String(Math.round((Number(value) || 0) * 100) / 100);
        }
    }
}
exports.formatValue = formatValue;
//# sourceMappingURL=formatters.js.map